import { ElScrollbar } from '@qsxy/element-plus-react';
import classNames from 'classnames';
import Menu from './Menu';

const Aside = () => {
	return (
		<aside className={classNames('ttn-layout-aside', 'ttn-aside-collapse')}>
			<div className="ttn-layout-sidebar-scroll">
				<ElScrollbar height="calc(100vh - 78px)">
					<nav className={classNames('ttn-sidebar-main', 'ttn-sidebar-collapse')}>
						<ul className="nav ttn-menu-nav">
							<Menu />
						</ul>
					</nav>
				</ElScrollbar>
			</div>
		</aside>
	);
};

export default Aside;
